var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsPinSoldPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18193 3.94954C1.59083 5.64764 0.594226 8.12129 0.632924 10.448C0.713733 15.3102 2.90536 17.1508 6.41018 23.8426C7.67268 26.7873 8.99036 29.9032 10.2436 35.0637C10.4177 35.8249 10.5876 36.532 10.6662 36.5933C10.7447 36.6546 10.9146 35.945 11.0888 35.1838C12.342 30.0232 13.6597 26.9099 14.9222 23.9652C18.427 17.2733 20.6186 15.4327 20.6994 10.5705C20.7381 8.24379 19.739 5.76766 18.1479 4.06956C16.3304 2.12977 13.5889 0.694173 10.6662 0.634142C7.74344 0.574072 4.9995 2.00974 3.18193 3.94954Z",
    fill: "#35763C",
    stroke: "#163119",
    strokeWidth: 1.26462
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6662 14.4675C12.7863 14.4675 14.505 12.7489 14.505 10.6288C14.505 8.50867 12.7863 6.79001 10.6662 6.79001C8.5461 6.79001 6.82739 8.50867 6.82739 10.6288C6.82739 12.7489 8.5461 14.4675 10.6662 14.4675Z",
    fill: "#163119"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 37.2185,
    fill: "white",
    transform: "translate(-0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsPinSoldPolicy);
export default __webpack_public_path__ + "static/media/maps-pin-SoldPolicy.15a582fab22f0d9a06a4fa30c634affa.svg";
export { ForwardRef as ReactComponent };